var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 146",
    style: {
      enableBackground: "new 0 0 300 146"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFCA05;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.6,113.7h1.7c0.8,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-1,0.6-1.7c0-0.7-0.2-1.2-0.6-1.6 c-0.4-0.4-0.9-0.6-1.6-0.6c-0.6,0-1.2,0.2-1.6,0.5s-0.6,0.8-0.6,1.3h-3.3c0-0.9,0.2-1.6,0.7-2.3c0.5-0.7,1.1-1.2,2-1.6 c0.8-0.4,1.8-0.6,2.8-0.6c1.8,0,3.1,0.4,4.1,1.3c1,0.8,1.5,2,1.5,3.5c0,0.8-0.2,1.5-0.7,2.1c-0.5,0.6-1.1,1.1-1.8,1.5 c0.9,0.3,1.6,0.8,2.1,1.5c0.5,0.7,0.7,1.5,0.7,2.4c0,1.5-0.5,2.6-1.6,3.5c-1.1,0.9-2.5,1.3-4.3,1.3c-1.7,0-3-0.4-4.1-1.3 c-1-0.9-1.6-2-1.6-3.5h3.3c0,0.6,0.2,1.1,0.7,1.5c0.5,0.4,1,0.6,1.7,0.6c0.8,0,1.4-0.2,1.8-0.6c0.4-0.4,0.7-1,0.7-1.6 c0-1.7-0.9-2.5-2.7-2.5h-1.7V113.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138.8,116.6c0,2.3-0.5,4-1.4,5.3c-0.9,1.2-2.3,1.8-4.2,1.8c-1.8,0-3.2-0.6-4.1-1.8c-1-1.2-1.4-2.9-1.5-5.1 v-3c0-2.3,0.5-4.1,1.4-5.3c1-1.2,2.3-1.8,4.1-1.8c1.8,0,3.2,0.6,4.1,1.8c1,1.2,1.4,2.9,1.5,5.1V116.6z M135.5,113.2 c0-1.4-0.2-2.4-0.6-3c-0.4-0.6-1-0.9-1.8-0.9c-0.8,0-1.3,0.3-1.7,0.9c-0.4,0.6-0.6,1.5-0.6,2.8v4c0,1.4,0.2,2.4,0.6,3 c0.4,0.7,1,1,1.8,1c0.8,0,1.4-0.3,1.7-0.9c0.4-0.6,0.5-1.6,0.6-2.9V113.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.6,106.9v16.5h-3.4v-13.8h-4.4l-0.3,5.8c-0.1,2-0.4,3.5-0.8,4.7c-0.4,1.1-1,2-1.7,2.5 c-0.7,0.5-1.8,0.8-3,0.8h-0.9v-2.7l0.6-0.1c0.9-0.1,1.5-0.6,1.8-1.5s0.6-2.4,0.7-4.7l0.3-7.6H160.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.5,116.2H167v4.4h7.7v2.7h-11.1v-16.5h11.1v2.8H167v3.9h6.5V116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M189.3,109.6h-5.1v13.8h-3.4v-13.8h-5v-2.8h13.5V109.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.4,117.9c-0.1,1.8-0.8,3.2-2,4.2c-1.2,1-2.7,1.5-4.7,1.5c-2.1,0-3.8-0.7-5-2.1c-1.2-1.4-1.8-3.4-1.8-5.9 v-1c0-1.6,0.3-3,0.8-4.2c0.6-1.2,1.4-2.1,2.4-2.8c1-0.6,2.3-1,3.6-1c1.9,0,3.4,0.5,4.6,1.5c1.2,1,1.8,2.5,2,4.3H206 c-0.1-1.1-0.4-1.8-0.9-2.3c-0.5-0.5-1.3-0.7-2.3-0.7c-1.1,0-2,0.4-2.6,1.2c-0.6,0.8-0.9,2.1-0.9,3.8v1.2c0,1.8,0.3,3.1,0.8,3.9 s1.4,1.2,2.6,1.2c1.1,0,1.8-0.2,2.4-0.7s0.8-1.2,0.9-2.2H209.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.4,123.4v-16.5h5.8c2,0,3.5,0.4,4.6,1.2c1,0.8,1.6,1.9,1.6,3.4c0,0.8-0.2,1.5-0.6,2.1 c-0.4,0.6-1,1.1-1.7,1.4c0.8,0.2,1.5,0.6,2,1.3c0.5,0.6,0.7,1.4,0.7,2.4c0,1.6-0.5,2.8-1.5,3.6c-1,0.8-2.5,1.2-4.3,1.2H217.4z  M220.8,113.8h2.5c1.7,0,2.6-0.7,2.6-2.1c0-0.8-0.2-1.3-0.7-1.6c-0.4-0.3-1.1-0.5-2.1-0.5h-2.4V113.8z M220.8,116.2v4.5h2.9 c0.8,0,1.4-0.2,1.9-0.6c0.5-0.4,0.7-0.9,0.7-1.6c0-1.5-0.8-2.3-2.4-2.3H220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.6,120h-6l-1.1,3.4h-3.6l6.2-16.5h3.2l6.2,16.5h-3.6L241.6,120z M236.6,117.2h4.1l-2.1-6.2L236.6,117.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.4,106.9l4.2,12l4.2-12h4.5v16.5h-3.4v-4.5l0.3-7.8l-4.5,12.3h-2.3l-4.5-12.3l0.3,7.8v4.5h-3.4v-16.5 H252.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.2,106.9h3.4v16.5h-3.4v-11l-6.6,11h-3.4v-16.5h3.4v11L278.2,106.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "113.1,23.3 162.6,23.3 162.6,36 128.1,36 128.1,51.1 158,51.1 158,63.8 128.1,63.8 128.1,79.9  162.9,79.9 162.9,92.6 113.1,92.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "190.2,36 170.5,36 170.5,23.4 225.1,23.4 225.1,36 205.4,36 205.4,92.7 190.2,92.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.5,69.3V47.7c0-16.7,13.1-25.6,28.4-25.6c13.3,0,27.3,7.1,27.3,22.8v2.7h-14.3v-1.4 c0-8.1-7.1-11.4-12.9-11.4c-6.3,0-13.4,3.4-13.4,12.3v21.6c0,7.7,6.2,12.2,13.8,12.2c5.8,0,12.5-3.3,12.5-11.5v-1.3h14.3v2.7 c0,15.7-13.5,22.8-26.9,22.8C241.1,93.8,227.5,85.7,227.5,69.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17.8,38.4 31.1,30.7 17.8,23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.4,53.8 57.8,61.5 85.1,45.9 85.1,84.2 57.8,100 31.1,84.6 31.1,53.8 71.1,30.7 57.8,23 57.8,23  17.8,46.1 17.8,92.3 57.8,115.4 97.8,92.5 97.8,38.1 97.8,23  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.f16d93b11950a809cf8db5506b5dc199.svg";
export { ForwardRef as ReactComponent };